import React from "react";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper";
import { FormLabel, Grid, InputAdornment, TextField, Typography } from "@mui/material";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import { useFormContext, useWatch } from "react-hook-form";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";
import FormSwitch from "../../../components/Forms/FormSwitch";
import AsyncProductAutocompleteTC from "../../../components/Forms/AsyncAutocomplete/Product/AsyncProductAutocompleteTC";
import { Alert } from "@mui/lab";
import _ from "lodash";
import FormCustomizableTextTC from "../../../components/Forms/FormCustomizableTextTC";
import Box from "@mui/material/Box";
import FormText from "../../../components/Forms/FormText";
import { InputValidation } from "../../../components/Forms/InputValidation";
import FormTextTC from "../../../components/Forms/FormTextTC";

function Serviceverzoeken() {
  const { menukaartVestigingId, vestigingId } = useFormContext();
  const extra_settings__tipFixedPriceWatch = useWatch({ name: "extra_settings__tipFixedPrice" });
  const extra_settings__tcFixedPriceValue = useWatch({ name: "extra_settings__tcFixedPrice" });
  const extra_settings__enableVoucherMasterVestigingValue = useWatch({
    name: "extra_settings__enableVoucherMasterVestiging",
  });
  const tipConfig = useWatch({ name: "extra_settings__tip_configuration" });

  const askForTip = useWatch({ name: "extra_settings__askForTip" });
  const tipProduct = useWatch({ name: "extra_settings__tip_product" });
  const appTarget = useWatch({ name: "appTarget" });

  let tipsIncorrectlyFormatted = false;
  if (askForTip) {
    if (!_.isObject(tipProduct) || tipProduct.blocked || !tipProduct.is_actief) {
      tipsIncorrectlyFormatted = true;
    }
  }

  return (
    <Grid container spacing={1}>
      <Grid alignContent={"flex-start"} item lg={6} xs={12}>
        <Card>
          <CardBody style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
            <Grid container spacing={1}>
              <Grid container item xs={12}>
                <Grid item xs={12}>
                  <h3>
                    <TranslationWrapper
                      tDefault={"Service verzoeken"}
                      tKey={"vestigingen.form.serviceverzoeken.headers.serviceVerzoeken"}
                    />
                  </h3>
                </Grid>
                <FormSwitchTC
                  name={"bediening"}
                  tDefault={"Bediening (service)"}
                  tKey={"vestigingen.form.overige.label.bediening"}
                />
                <FormSwitchTC
                  name={"rekening"}
                  tDefault={"Rekening (service)"}
                  tKey={"vestigingen.form.overige.label.rekening"}
                />
              </Grid>
            </Grid>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <Grid container>
              <Grid item xs={12}>
                <h3>
                  <TranslationWrapper
                    tDefault={"Transaction costs"}
                    tKey={"vestigingen.form.serviceverzoeken.headers.kosten"}
                  />
                </h3>
              </Grid>

              <FormControlledInputTC
                name={"extra_settings__ntcAbove"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                tDefault={"Geen transactiekosten bij bestelling boven"}
                tKey={"vestigingen.form.delivery_settings.label.extra_settings__ntcAbove"}
                type={"currency"}
              />
              <AsyncProductAutocompleteTC
                async_url={`core/producten/search?fields=id as value, naam as label,id,naam,snaam,blocked,is_actief,prijs&per_page=50&sort_field=naam&vestiging_id=${menukaartVestigingId}`}
                key={"extra_settings__tcProduct" + menukaartVestigingId}
                name={"extra_settings__tcProduct"}
                tDefault={"Transactiekosten product"}
                tKey={"vestigingen.form.delivery_settings.label.extra_settings__tcProduct"}
              />
              <FormSwitchTC
                name={"extra_settings__tcFixedPrice"}
                tDefault={"Percentage or fixed price"}
                tKey={"vestigingen.form.serviceverzoeken.label.tcPercentageOrFixedPriceToggle"}
              />
              <FormControlledInputTC
                name={"extra_settings__tcCost"}
                rules={{
                  min: {
                    value: 0,
                    message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                  },
                }}
                tDefault={extra_settings__tcFixedPriceValue ? "Prijs" : "Percentage"}
                tKey={
                  extra_settings__tcFixedPriceValue
                    ? "vestigingen.form.serviceverzoeken.label.extra_settings__tcCostPrice"
                    : "vestigingen.form.serviceverzoeken.label.extra_settings__tcCostPercentage"
                }
                type={extra_settings__tcFixedPriceValue ? "currency" : "number"}
              />
            </Grid>
          </CardBody>
        </Card>
      </Grid>
      <Grid alignContent={"flex-start"} item lg={6} xs={12}>
        <Card>
          <CardBody>
            <Grid container xs={12}>
              <Grid item xs={12}>
                <h3>
                  <TranslationWrapper tDefault={"Fooien"} tKey={"vestigingen.form.serviceverzoeken.headers.fooien"} />
                </h3>
              </Grid>
              {tipsIncorrectlyFormatted ? (
                <Alert severity={"warning"}>
                  <TranslationWrapper
                    tDefault={"Product is not selected, blocked or inactive, tipping will not work"}
                    tKey={"vestigingen.form.serviceverzoeken.warnings.fooien"}
                  />
                </Alert>
              ) : null}
              <FormSwitchTC
                name={"extra_settings__askForTip"}
                tDefault={"Vraag om fooi"}
                tKey={"vestigingen.form.overige.label.askForTip"}
              />
              {appTarget === "appv5.js" ? (
                <FormCustomizableTextTC
                  model={"vestiging"}
                  modelId={vestigingId}
                  tDefault={"Tip Message"}
                  tKey={"vestigingen.form.serviceVerzoeken.label.translateTipMessage"}
                  translatableText={"add_tip_message"}
                />
              ) : null}
              <AsyncProductAutocompleteTC
                async_url={`core/producten/search?fields=id as value,naam as label,blocked,id,naam,snaam,is_actief,blocked,prijs&per_page=15000&sort_field=naam&vestiging_id=${menukaartVestigingId}`}
                key={"extra_settings__tipProductId" + menukaartVestigingId}
                name={"extra_settings__tipProductId"}
                tDefault={"Fooi product"}
                tKey={"vestigingen.form.serviceverzoeken.label.extra_settings__tipProductId"}
              />
              <Typography fontSize={"1.5em"} sx={{ my: 2 }} variant={"h3"}>
                Tip percentages
              </Typography>
              <FormTextTC
                fieldProps={{
                  InputProps: {
                    endAdornment: <InputAdornment position={"end"}>%</InputAdornment>,
                  },
                }}
                name={"extra_settings__tip_configuration.lower_tip_percentage"}
                rules={{
                  ...InputValidation.PERCENTAGE,
                }}
                tDefault={"Lowest tip percentage"}
                tKey={"tipping.percentages.low"}
              />
              <FormTextTC
                fieldProps={{
                  InputProps: {
                    endAdornment: <InputAdornment position={"end"}>%</InputAdornment>,
                  },
                }}
                name={"extra_settings__tip_configuration.medium_tip_percentage"}
                rules={{
                  ...InputValidation.PERCENTAGE,
                }}
                tDefault={"Medium tip percentage"}
                tKey={"tipping.percentages.medium"}
              />
              <FormTextTC
                fieldProps={{
                  InputProps: {
                    endAdornment: <InputAdornment position={"end"}>%</InputAdornment>,
                  },
                }}
                name={"extra_settings__tip_configuration.high_tip_percentage"}
                rules={{
                  ...InputValidation.PERCENTAGE,
                }}
                tDefault={"Highest tip percentage"}
                tKey={"tipping.percentages.high"}
              />
              {appTarget !== "appv5.js" ? (
                <>
                  <Grid item xs={12}>
                    <h3>
                      <TranslationWrapper
                        tDefault={"Automatisch toevoegen van fooi bij bestelling"}
                        tKey={"vestigingen.form.serviceverzoeken.headers.autoAddTip"}
                      />
                    </h3>
                  </Grid>
                  <FormSwitchTC
                    name={"extra_settings__autoAddTip"}
                    tDefault={"Automatisch fooien actief"}
                    tKey={"vestigingen.form.overige.label.autoAddTip"}
                  />
                  <FormFieldTwoColumns
                    name={"extra_settings__tipFixedPrice"}
                    tDefault={"Percentage"}
                    tKey={"vestigingen.form.serviceverzoeken.label.extra_settings__tipFixedPriceFalse"}
                  >
                    <FormSwitch />
                    <FormLabel>
                      <TranslationWrapper
                        tDefault={"Vaste prijs"}
                        tKey={"vestigingen.form.serviceverzoeken.label.extra_settings__tipFixedPriceTrue"}
                      />
                    </FormLabel>
                  </FormFieldTwoColumns>

                  <FormControlledInputTC
                    name={"extra_settings__tipCost"}
                    suffix={extra_settings__tipFixedPriceWatch ? null : " %"}
                    tDefault={extra_settings__tipFixedPriceWatch ? "Prijs" : "Percentage"}
                    tKey={
                      extra_settings__tipFixedPriceWatch
                        ? "vestigingen.form.serviceverzoeken.label.extra_settings__tipCostPrice"
                        : "vestigingen.form.serviceverzoeken.label.extra_settings__tipCostPercentage"
                    }
                    type={extra_settings__tipFixedPriceWatch ? "currency" : "number"}
                  />
                </>
              ) : null}
            </Grid>
          </CardBody>
        </Card>
      </Grid>
    </Grid>
  );
}

export default Serviceverzoeken;
